import { z } from 'zod';

const ProjectSchema = z
  .object({
    id: z.string(),
  })
  .passthrough();

export type Project = z.infer<typeof ProjectSchema>;

export const CreateProjectResponseSchema = z.object({
  project: ProjectSchema,
});

export type CreateProjectResponse = z.infer<typeof CreateProjectResponseSchema>;
